import React, { useState } from "react";

interface ViatorAwardBadgeProps {
  awardType: string;
  isHovered: boolean;
}

const ViatorAwardBadge: React.FC<ViatorAwardBadgeProps> = ({
  awardType,
  isHovered,
}) => {
  if (!awardType) return null;

  const year = awardType ? awardType.split(" ")[3] : "";

  return (
    <div
      className={`absolute transition-all duration-[450] ease-in-out w-7 h-7 -bottom-2 right-2 ring-[1.5px] ring-[#006B6F] whitespace-nowrap bg-white rounded-full shadow-md z-10 flex items-center group overflow-hidden hover:cursor-default ${
        isHovered ? "w-[80%]" : "justify-center"
      }`}
    >
      <i
        className={`fa-solid fa-award text-[#006B6F] text-[16px] ${
          isHovered ? "pl-4" : ""
        }`}
      ></i>
      <span
        className={`w-full text-center text-[12px] font-medium text-neutral-900 ${
          isHovered ? "" : "hidden"
        }`}
      >
        Viator Experience Award {year}
      </span>
    </div>
  );
};

export default ViatorAwardBadge;
